import React from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Grid,
  Button,
  Box
} from '@mui/material';

import QuizIcon from '@mui/icons-material/Quiz';
import HeartBrokenIcon from '@mui/icons-material/HeartBroken';

export default function ClinicalEvaluationsSection({
  onAsthmaQuestionnaireUpload,
  onCVRiskFactorsUpload
}) {
  const handleFileUpload = (callback) => (e) => {
    const file = e.target.files[0];
    if (file?.type === 'text/plain') {
      const reader = new FileReader();
      reader.onload = (e) => callback(e.target.result);
      reader.readAsText(file);
    }
  };

  const downloadTemplate = (filename, content) => {
    const blob = new Blob([content], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <Card sx={{ mb: 6 }}>
      <CardHeader title="Clinical Evaluations" sx={{ backgroundColor: '#f5f5f5' }} />
      <CardContent>
        <Grid container spacing={4}>

          {/* Asthma - ACT */}
          <Grid item xs={12}>
            <Typography variant="subtitle1" sx={{ display: 'flex', alignItems: 'center' }}>
              <QuizIcon sx={{ mr: 1 }} /> Asthma Control Test (ACT) Questionnaire
            </Typography>
            <Box mt={1} display="flex" gap={2}>
              <Button variant="outlined" component="label">
                Upload .txt file
                <input type="file" hidden onChange={handleFileUpload(onAsthmaQuestionnaireUpload)} accept=".txt" />
              </Button>
              <Button
                variant="text"
                onClick={() =>
                  downloadTemplate(
                    'asthma_questionnaire_template.txt',
                    'ACT Score: 19/25\nInterpretation: Moderate control\nNotes: Adjust therapy accordingly'
                  )
                }
              >
                Download template
              </Button>
            </Box>
          </Grid>

          {/* Cardiovascular risk */}
          <Grid item xs={12}>
            <Typography variant="subtitle1" sx={{ display: 'flex', alignItems: 'center' }}>
              <HeartBrokenIcon sx={{ mr: 1 }} /> Cardiovascular Risk Factors (10-year)
            </Typography>
            <Box mt={1} display="flex" gap={2}>
              <Button variant="outlined" component="label">
                Upload .txt file
                <input type="file" hidden onChange={handleFileUpload(onCVRiskFactorsUpload)} accept=".txt" />
              </Button>
              <Button
                variant="text"
                onClick={() =>
                  downloadTemplate(
                    'cardiovascular_risk_template.txt',
                    'Age: 65\nSex: Male\nTotal cholesterol: 210\nHDL: 48\nSystolic BP: 138\nSmoker: Yes\nDiabetes: No\n10-year risk: 18%'
                  )
                }
              >
                Download template
              </Button>
            </Box>
          </Grid>

        </Grid>
      </CardContent>
    </Card>
  );
}
